export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13981.475b1e60.jpg";